<template>
  <div class="chat-input-control">
    <div class="text-box-wrap">
      <CustomTextarea
        v-model="message"
        @ctrl_enter="sendMessage({ message })"
      />

      <div
        class="send-message"
        :class="{
          disabled: message.trim().length === 0,
          clickable: message.trim().length > 0,
          reopen: isClosed,
        }"
        @click="sendMessage({ message })"
      >
        <span v-if="isClosed">{{ labels.reopenTicket }}</span>
        <i
          class="material-icons"
          :alt="
            message.trim().length
              ? labels.sendTicketMessage
              : labels.sendTicketMessageDisabled
          "
        >
          send
        </i>
      </div>
    </div>
    <small class="label-text text-left hide-mobile">{{
      labels.controlEnterMessage
    }}</small>
    <div class="send-as-anonymous" v-if="canShowAnonymous">
      <Switches
        v-model="isAnonymous"
        type-bold="true"
        class="float-left m-1"
        theme="custom"
        color="primary"
      />
      <span class="text-gray03 pl-3">{{ labels.sendAsAnonymous }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Switches from 'vue-switches'
import { APP_MODAL_OPEN, SIMPLE } from '@/components/Modal/Enum'
import CustomTextarea from '@/components/Shared/Form/CustomTextarea.vue'

const props = {
  anonymousOption: {
    type: Boolean,
    default: true,
  },
  isClosed: {
    type: Boolean,
    default: false,
  },
}

export default {
  props,
  components: { Switches, CustomTextarea },
  data() {
    return {
      message: '',
      isAnonymous: this.anonymousOption,
      internalShowAnonymous: true,
    }
  },
  watch: {
    anonymousOption(value) {
      this.internalShowAnonymous = value
      this.isAnonymous = value
    },
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels: function() {
      return this.resources.page.home.feedbacks.tickets.inputControl
    },
    canShowAnonymous: function() {
      return this.anonymousOption && this.internalShowAnonymous
    },
  },
  methods: {
    sendMessage({ message }) {
      if (!message.trim()) return
      const call =
        this.canShowAnonymous && !this.isAnonymous
          ? this.callModalAnonymous
          : this.emitSendMessage
      call(message)
    },

    emitSendMessage(message) {
      this.$emit('sendMessage', {
        message: message.trim(),
        isAnonymous: this.isAnonymous,
      })

      this.resetState()
    },

    callModalAnonymous(message) {
      this.$root.$emit(APP_MODAL_OPEN, {
        modal: SIMPLE, // tipo de modal pode ser consultado na store "modalApp.js"
        payload: {
          title: this.labels.modal.title,
          text: this.labels.modal.text,
          options: {
            okTitle: this.labels.modal.yes,
            cancelTitle: this.labels.modal.no,
            onOk: () => this.emitSendMessage(message),
            onCancel: () => (this.isAnonymous = true),
          },
        },
      })
    },

    resetState() {
      this.message = ''
      this.internalShowAnonymous = this.isAnonymous
    },
  },
}
</script>

<style lang="scss">
@import '~@/styles/custom/colors';

$max-height: 80px; // textarea max height

.chat-input-control {
  align-items: center;
  background: map-get($theme-colors, 'light02');
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0.7rem 0.7rem 0.3rem;

  .label-text {
    text-align: left;
    width: 100%;
    @media (max-width: 768px) {
      opacity: 0;
      height: 5px;
    }
  }

  .text-box-wrap {
    align-items: center;
    display: flex;
    width: 100%;

    .textarea-styled {
      align-items: center;
      background: white;
      border: 1px solid map-get($theme-colors, 'octonary01');
      border-radius: 25px;
      display: flex;
      flex-grow: 1;
      margin-bottom: 0;
      max-height: $max-height;
      min-height: 50px;
      outline: none;
      overflow: hidden;
      position: relative;
      word-break: break-all;

      .textarea-styled-wrap {
        align-items: center;
        border: none;
        display: flex;
        flex-grow: 1;
        line-height: initial;
        margin-bottom: 0;
        max-height: 100%;
        min-height: 24px;
        outline: none;
        overflow: hidden;
        position: relative;
        word-break: break-all;
        width: 100%;
      }

      &:focus {
        box-shadow: 0 0 6px
          transparentize(map-get($theme-colors, 'octonary01'), 0.16);
      }

      textarea {
        bottom: 0;
        border: none;
        height: 100%;
        left: 0;
        margin-bottom: 0;
        max-height: $max-height;
        outline: none;
        padding: 0 10px;
        position: absolute;
        resize: none;
        right: 0;
        top: 0;
        width: 100%;
        word-break: break-word;
      }

      .opacity-0 {
        max-height: $max-height;
        padding: 0 10px;
        width: 100%;
        opacity: 0;
      }
    }

    .reopen {
      width: 155px;
    }

    .send-message {
      align-items: center;
      background: map-get($theme-colors, 'primary');
      border-radius: 40px;
      color: white;
      cursor: pointer;
      display: inline-flex;
      font-size: 23px;
      height: 50px;
      justify-content: center;
      margin-left: 1rem;
      min-width: 50px;
      padding-left: 2px;

      &.disabled {
        background: map-get($theme-colors, 'gray01');
      }

      span {
        font-size: 10pt;
        margin: 5px;
      }
    }
  }

  .send-as-anonymous {
    align-items: center;
    display: flex;
    flex-basis: 100%;

    .vue-switcher--bold div {
      top: 0px;
    }
  }
}
</style>
